export enum EstimatedEditedEnum {
  Estimated = 1,
  Edited = 2,
  Adjusted = 4,
}
